import React, { useEffect, useState } from 'react';
import Plot from 'react-plotly.js';
import useHttp from '../../../hook/use-http';
import { API_URL_MAIN, INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates_bus';
import styles from './BDT_Bus.module.css';
import ChartLoader from './ChartLoader_bus';
import regression from 'regression';

const config = {
    scrollZoom: false,
    showLink: false,
    modeBarButtonsToRemove: ['toImage', 'zoom2d', 'pan', 'pan2d', 'autoScale2d'],
    displayLogo: false,
    displayModeBar: false,
};

// const performPolynomialRegression = (odometer, soh) => {
//     if (odometer.length < 3) {
//         return {
//             odoExtrap: [0, 100000, 200000],
//             sohExtrap: [100, 80, 60],
//             rulPoint: 100000
//         };
//     }

//     // **Step 1: Remove Outliers (IQR Method)**
//     const computeIQR = (arr) => {
//         let sorted = [...arr].sort((a, b) => a - b);
//         let Q1 = sorted[Math.floor(0.25 * sorted.length)];
//         let Q3 = sorted[Math.floor(0.75 * sorted.length)];
//         let IQR = Q3 - Q1;
//         return { Q1, Q3, IQR };
//     };

//     let { Q1, Q3, IQR } = computeIQR(odometer);
//     let lowerBound = Q1 - 1.5 * IQR;
//     let upperBound = Q3 + 1.5 * IQR;

//     let filteredData = odometer
//         .map((odo, i) => ({ odo, soh: soh[i] }))
//         .filter(({ odo }) => odo >= lowerBound && odo <= upperBound);

//     let x_sorted = filteredData.map(d => d.soh);
//     let y_sorted = filteredData.map(d => d.odo);

//     if (x_sorted.length < 3) {
//         return {
//             odoExtrap: [0, 100000, 200000],
//             sohExtrap: [100, 80, 60],
//             rulPoint: 100000
//         };
//     }

//     // **Step 2: Compute Linear Regression (Least Squares Method)**
//     let n = x_sorted.length;
//     let sumX = x_sorted.reduce((a, b) => a + b, 0);
//     let sumY = y_sorted.reduce((a, b) => a + b, 0);
//     let sumXY = x_sorted.reduce((sum, x, i) => sum + x * y_sorted[i], 0);
//     let sumX2 = x_sorted.reduce((sum, x) => sum + x * x, 0);

//     let m = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
//     let c = (sumY - m * sumX) / n;

//     // Function to predict odometer given SOH
//     const predictOdometer = (soh) => m * soh + c;

//     // **Step 3: Generate Predictions**
//     let sohValues = Array.from({ length: 1000 }, (_, i) => 70 + (i / 1000) * 30);
//     let odometerPredictions = sohValues.map(predictOdometer);

//     // **Step 4: Find RUL (Odometer where SOH = 80)**
//     let rulPoint = predictOdometer(80);

//     return {
//         odoExtrap: odometerPredictions,
//         sohExtrap: sohValues,
//         rulPoint
//     };
// };

const LineChart = (props) => {
    const { packType, apiEnd } = props.data;
    const { isLoading, error, sendReq: fetchData } = useHttp();
    // const [maxSoh, setMaxSoh] = useState(null);
    const [latestSOH, setLatestSOH] = useState(null)
    const [sohPlots, setSohPlots] = useState([1]);
    const [odometerPlots, setOdometerPlots] = useState([1]);

    const [rulPoint, setRulPoint] = useState(0);
    const [odoExtrap, setOdoExtrap] = useState([]);
    const [sohExtrap, setSohExtrap] = useState([]);
    const [legendVisible, setLegendVisible] = useState(false);
    const [lastObservedOdo, setLastObservedOdo] = useState(null);



    /* Old useEffect with API call */
    // useEffect(() => {
    //     fetchData(
    //         {
    //             url: API_URL_MAIN + `battery_digital_twin/${apiEnd}`,
    //             body: { filterdata: props.filterdata }
    //         },
    //         (data) => {
    //             if (data?.graph_data?.length) {
    //                 let filteredData = data.graph_data.filter(item =>
    //                     item?.SOH_Value !== null && item?.SOH_Value !== undefined &&
    //                     item?.odometer !== null && item?.odometer !== undefined
    //                 );

    //                 // Group data by SOH_Value and select the highest odometer for each SOH value
    //                 const groupedData = filteredData.reduce((acc, item) => {
    //                     if (!acc[item.SOH_Value]) {
    //                         acc[item.SOH_Value] = item;
    //                     } else {
    //                         // If the current odometer is higher, update the data
    //                         if (item.odometer > acc[item.SOH_Value].odometer) {
    //                             acc[item.SOH_Value] = item;
    //                         }
    //                     }
    //                     return acc;
    //                 }, {});

    //                 // Convert grouped data to arrays for plotting
    //                 let sohData = Object.values(groupedData).map(item => Number(item.SOH_Value));
    //                 let odometerData = Object.values(groupedData).map(item => Number(item.odometer));

    //                 setOdometerPlots(odometerData);
    //                 setSohPlots(sohData);
    //                 // setMaxSoh(Math.max(...sohData));
    //                 // setLatestSOH(sohData.at(-1))
    //                 setLatestSOH(Math.min(...sohData))
    //                 console.log('Math.min: ', Math.min(...sohData));


    //                 // Perform Regression
    //                 // const { odoExtrap, sohExtrap, rulPoint } = performPolynomialRegression(odometerData, sohData);

    //                 // Update State
    //                 setOdoExtrap(odoExtrap);
    //                 setSohExtrap(sohExtrap);
    //                 setRulPoint(rulPoint);
    //             } else {
    //                 setOdometerPlots([1]);
    //                 setSohPlots([1]);
    //                 setLatestSOH(null)
    //                 // setMaxSoh(null);
    //             }
    //         }
    //     );
    // }, [props]);

    /* New useEffect with curve plotting effect */
    useEffect(() => {
        fetchData(
            {
                url: API_URL_MAIN + `battery_digital_twin/${apiEnd}`,
                body: { filterdata: props.filterdata }
            },
            (data) => {
                console.log('Graph data: ', data);

                if (data?.graphData?.length) {

                    // 1. Process actual observations (graph_data)
                    let filteredData = data.graphData.filter(item =>
                        item?.SOH_Value !== null && item?.SOH_Value !== undefined &&
                        item?.odometer !== null && item?.odometer !== undefined
                    );
                    const groupedData = filteredData.reduce((acc, item) => {
                        if (!acc[item.SOH_Value] || item.odometer > acc[item.SOH_Value].odometer) {
                            acc[item.SOH_Value] = item;
                        }
                        return acc;
                    }, {});

                    const actualSoh = Object.values(groupedData).map(item => Number(item.SOH_Value));
                    const actualOdo = Object.values(groupedData).map(item => Number(item.odometer));

                    setOdometerPlots(actualOdo);
                    setSohPlots(actualSoh);
                    setLatestSOH(Math.min(...actualSoh));

                    // 2. Use backend exponential curve
                    const predicted = data?.predicted_graph_data || [];

                    const predictedOdo = predicted.map(d => Number(d.odometer));
                    const predictedSoh = predicted.map(d => Number(d.Predicted_SOH));

                    setOdoExtrap(predictedOdo);
                    setSohExtrap(predictedSoh);

                    // 3. Compute RUL from backend curve
                    // const rulFromApi = predicted.find(p => p.Predicted_SOH <= 80);
                    // setRulPoint(rulFromApi ? Number(rulFromApi.odometer) : null);

                    /* New logic */
                    // ---- DIRECT RUL USING BACKEND ORDER ----

                    // Last observed odometer (take last object from filteredData)
                    const lastObs =
                        filteredData.length > 0
                            ? Number(filteredData[filteredData.length - 1].odometer)
                            : null;

                    // Last predicted odometer where Predicted_SOH == 80 (take LAST in array)
                    const lastPred =
                        predicted.length > 0
                            ? Number(predicted[predicted.length - 1].odometer)
                            : null;

                    // Save state (these will never be off-by-1)
                    setRulPoint(lastPred);
                    setLastObservedOdo(lastObs);   // <-- You need to create this state


                } else {
                    setOdometerPlots([1]);
                    setSohPlots([1]);
                    setLatestSOH(null);
                }
            }
        );
    }, [props]);

    const rulInLakhs = (rulPoint / 100000).toFixed(2);
    console.log('rulPoint: ', rulPoint)


    const lastObserved = Math.max(...odometerPlots, 0);
    const lastPredicted = Math.max(...odoExtrap, 0);

    const baseMax = Math.max(lastObserved, lastPredicted);

    // Add only 2–3% padding
    const xMax = baseMax + baseMax * 0.03;

    // Start slightly before min observed
    const xMin = Math.max(Math.min(...odometerPlots) * 0.97, 0);

    const remainingLife =
        rulPoint != null && lastObservedOdo != null
            ? (rulPoint - lastObservedOdo)
            : "--";

    console.log('rul lastObserved: ', lastObserved)
    console.log('rul lastPredicted: ', lastPredicted)



    return (
        <>
            <div className='d-flex justify-content-center mt-2'>
                <div className='bg-white p-1 m-1 w-50 shadow-sm rounded-3'>
                    <div className='font-weight-bold '>Latest SOH {packType}</div>
                    <div className={`${styles.soh_heading}`}>{latestSOH ? latestSOH : "--"}</div>
                </div>
            </div>
            <div className={`bg-white w-100 my-4 d-flex justify-content-center align-content-center shadow-sm rounded-3 ${styles.card_height}`}>
                {isLoading ? <ChartLoader zIndex={1}/> :
                    <Plot
                        data={[
                            {
                                x: odometerPlots,
                                y: sohPlots,
                                mode: "markers",
                                type: "scatter",
                                marker: { color: "blue", size: 5 },
                                name: "Observed Data",
                                // legendgroup: 'dos'
                            },
                            {
                                x: odoExtrap,
                                y: sohExtrap,
                                mode: "lines",
                                type: "scatter",
                                line: { color: "red", dash: "dash", width: 2 },
                                name: "Extrapolated Line",
                                // legendgroup: 'dos'
                            },
                            // {
                            //     x: [Math.min(...odometerPlots) * 0.9, rulPoint + 5000],
                            //     y: [80, 80],
                            //     mode: "lines",
                            //     type: "scatter",
                            //     line: { color: "green", dash: "dash", width: 2 },
                            //     name: "Threshold (80%)",
                            //     // legendgroup: 'dos'
                            // },
                            // {

                            //     x: [rulPoint, rulPoint],
                            //     y: [70, 102],
                            //     mode: "lines",
                            //     type: "scatter",
                            //     line: { color: "#bbcf08", dash: 'dash', width: 2 },
                            //     name: `RUL: ${rulInLakhs} lakhs`,
                            // }

                            {
                                x: [0, 0],
                                y: [0, 0],
                                mode: "lines",
                                line: { width: 1, color: "rgba(0,0,0,0)" },
                                showlegend: true,
                                name: `Remaining Life: ${remainingLife}`,
                            },

                        ]}
                        layout={{
                            width: 280,
                            height: 280,
                            margin: { t: 25, l: 35, b: 40, r: 30 },
                            xaxis: {
                                // title: { text: 'Odometer' },
                                title: { text: 'Cycle Count' },
                                // range: [Math.min(...odometerPlots) * 0.9, Math.max(rulPoint + 5000, Math.max(...odometerPlots) * 1.1)],
                                range: [xMin, xMax],
                                linecolor: 'black',
                                mirror: true,
                            },
                            yaxis: {
                                // title: { text: 'SOH' }, range: [75, 102],
                                title: { text: 'SOH' }, range: [80, 102],
                                showline: true,
                                linecolor: 'black',
                                mirror: true
                            },
                            dragmode: false,
                            showlegend: true,
                            legend: {
                                x: 1.00001,
                                y: 1,
                                xanchor: 'right',
                                yanchor: 'top',
                                orientation: 'y',
                                font: { size: 6 },
                                itemsizing: 'constant',
                                itemwidth: 30,
                                traceorder: 'normal',
                                bordercolor: "#8b8b8b8a",
                                borderwidth: 1

                            }

                        }}
                        config={config}
                    />
                }
            </div>
        </>
    );
};
export default LineChart;
